import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Filter, LayoutGrid, List, RefreshCw, Search, X } from 'lucide-react';

import styles from './TrackerToolbar.module.scss';

const TrackerToolbar = ({
  searchQuery,
  onSearchChange,
  viewMode,
  onViewModeChange,
  filtersCount,
  onFiltersToggle,
  onRefresh,
  isSearching,
  isSearchLoading,
  direction,
  isMobile,
}) => {
  const { t } = useTranslation('common');

  const searchPlaceholder =
    direction === 'their'
      ? t('tracker.searchSentPlaceholder', 'Search by job title or candidate name...')
      : t('tracker.searchReceivedPlaceholder', 'Search by job title or referrer name...');

  return (
    <div className={styles.toolbar}>
      <div className={styles.left}>
        {/* Search */}
        <div className={styles.searchContainer}>
          <Search size={16} className={styles.searchIcon} />
          <input
            type="text"
            className={styles.searchInput}
            placeholder={searchPlaceholder}
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          {searchQuery && (
            <button type="button" className={styles.clearSearch} onClick={() => onSearchChange('')}>
              <X size={14} />
            </button>
          )}
          {isSearchLoading && <div className={styles.searchSpinner} />}
        </div>

        {/* Filters */}
        <button type="button" className={styles.filterBtn} onClick={onFiltersToggle}>
          <Filter size={16} />
          <span>{t('tracker.filters', 'Filters')}</span>
          {filtersCount > 0 && <span className={styles.filterBadge}>{filtersCount}</span>}
        </button>
      </div>

      <div className={styles.right}>
        {/* Refresh */}
        <button type="button" className={styles.iconBtn} onClick={onRefresh} title={t('tracker.refresh', 'Refresh')}>
          <RefreshCw size={16} />
        </button>

        {/* View toggle — hidden on mobile (always list view) */}
        {!isMobile && (
          <div className={styles.viewToggle}>
            <button
              type="button"
              className={classNames(styles.viewBtn, { [styles.viewBtnActive]: viewMode === 'board' })}
              onClick={() => onViewModeChange('board')}
              title={t('tracker.boardView', 'Board View')}
            >
              <LayoutGrid size={16} />
            </button>
            <button
              type="button"
              className={classNames(styles.viewBtn, { [styles.viewBtnActive]: viewMode === 'list' })}
              onClick={() => onViewModeChange('list')}
              title={t('tracker.listView', 'List View')}
            >
              <List size={16} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TrackerToolbar;
